<template>
    <div class="profile-short">
        <form v-if="edit" @submit.prevent="save">
            <div class="field">
                <div class="control">
                    <input class="input" type="text" v-model="short" id="short" name="short"
                           maxlength="50" :placeholder="$t('students.profile.shortPlaceholder')"
                           :data-vv-as="$t('students.profile.short')" v-validate="'required|max:50'"/>
                </div>

                <p v-if="veeErrors.has('short')" class="help is-danger">{{veeErrors.first('short')}}</p>
            </div>

            <div class="field is-grouped">
                <div class="control">
                    <a class="button is-light" @click.prevent="toggle">
                        {{$t('global.actions.cancel')}}
                    </a>
                </div>

                <div class="control">
                    <button class="button is-primary" >{{$t('global.actions.save')}}</button>
                </div>
            </div>
        </form>

        <p v-else>
            {{short}}
            <a v-if="currentAccountIsSameAs(student)"
                  @click.prevent="toggle">
                {{$t('global.actions.edit')}}
            </a>
        </p>
    </div>
</template>

<script>
    import AccountMixin from '@/global/mixins/AccountMixin';
    import StudentService from '@/taskflex/students/services/StudentService';

    export default {
        data() {
            return {
                edit: false,
                short: null,
            };
        },

        mixins: [AccountMixin],

        props: {
            student: {
                type: Object,
            },
        },

        watch: {
            student() {
                const { short } = this.student;

                this.short = short;
            },
        },

        mounted() {
            const { short } = this.student;

            this.short = short;
        },

        methods: {
            save() {
                const { student } = this;

                this.$validator.validateAll().then((result) => {
                    if (!result) {
                        return;
                    }

                    const options = {
                        short: this.short,
                    };

                    StudentService.update(student.id, options, () => {
                        this.$eventHub.$emit('students.profile.update');

                        this.toggle();
                    });
                });
            },

            toggle() {
                const { short } = this.student;
                this.short = short;

                this.edit = !this.edit;
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/taskflex/students/components/profile/Short.vue